// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".receipt-view-dialog{margin:0 15px}.receipt-view-dialog__frame{min-height:200px}.receipt-view-dialog__frame--html{min-width:370px}.receipt-view-dialog__text{text-align:center;margin-top:50px}.receipt-view-dialog .e-link{font-size:12px!important}.receipt-view-dialog .v-card{padding-top:30px}.receipt-view-dialog .v-card .v-card__actions{padding:0}", ""]);
// Exports
module.exports = exports;
